import SyncProblemIcon from "@mui/icons-material/SyncProblem";

export const SyncBadge = () => {
  return (
    <div
      style={{
        position: "absolute",
        top: 0,
        right: 0,
        width: 8,
        height: 8,
        backgroundColor: "#ff4444",
        color: "white",
        borderRadius: "50%",
        zIndex: 9999,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <SyncProblemIcon style={{ width: "100%", height: "100%" }} />
    </div>
  );
};
